import Popup from "reactjs-popup";
import { cn, renderBankLogo } from "../../utils/utils";
import PropTypes from "prop-types";
import Pagination from "../../shared/Pagination";
import { useCallback, useState } from "react";
import { useGetDestinationIbans } from "../../lib/queries/queriesAndMutations";
import { useDebounce } from "../../hooks/useDebounce";

const MemorizedIbans = ({ className, setValue, clearErrors }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState({
    iban_nickname: "",
    iban: "",
  });

  const debouncedQueryParams = useDebounce(searchTerm, 1024);
 
  const pageSize = 20;
  const onPageChange = useCallback((page) => setCurrentPage(page), []);
  const { data: destinations } = useGetDestinationIbans({debouncedQueryParams, currentPage });

 

  const handleSelection = (item, close) => {
    setValue("iban", item?.iban.slice(2));
    setValue("iban_nickname", item?.iban_nickname);
    clearErrors("iban");
    if (close) close();
  };
  const handleSearchInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSearchTerm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Popup
      trigger={
        <button className="popup-btn"
        >
          شباهای ذخیره‌شده{" "}
        </button>
      }
      modal
      nested
    >
      {(close) => {
        return (
          <div className="p-2  rounded-md bg-white ">
            <div className="flex justify-between p-2 ">
              <p className="text-lg font-semibold text-slate-700">
                {" "}
                شباهای ذخیره‌شده{" "}
              </p>
              <button onClick={close}>
                <img
                  className="cursor-pointer"
                  src={"/icons/close-icon.svg"}
                  alt="close-icon"
                  width={24}
                  height={24}
                />
              </button>
            </div>

            <div className="bg-slate-100 p-4 rounded-xl space-y-4">
              <p className="text-sm font-semibold text-slate-700">جستجو</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="iban_nickname"
                    className="text-sm text-slate-600"
                  >
                    نام مستعار
                  </label>
                  <input
                    id="iban_nickname"
                    name="iban_nickname"
                    type="text"
                    className="border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={handleSearchInputChange}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label htmlFor="iban" className="text-sm text-slate-600">
                    شبا
                  </label>
                  <input
                    id="iban"
                    name="iban"
                    type="number"
                    className="border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={handleSearchInputChange}
                  />
                </div>
              </div>
            </div>

            {!destinations?.count ? (
              <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
                <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
                  <img
                    src="/images/bankcard.svg"
                    alt=""
                    className="max-w-[40px] max-h-[40px]"
                  />
                  <p> شماره شبای ذخیره شده ای برای شما ثبت نشده است!</p>
                </div>
              </div>
            ) : (
              <>
                <div
                  className={cn(
                    "col-span-1 xl:col-span-1 flex flex-col gap-1 p-4 bg-white min-w-[320px] rounded-md max-h-[50vh] overflow-y-scroll vanda",
                    className
                  )}
                >
                  {destinations?.results.map((item) => (
                    <>
                      <div
                        key={item.destination_iban}
                        className="flex gap-2 bg-neutral-10 hover:bg-neutral-20 p-2 rounded-md items-center cursor-pointer "
                        onClick={() => handleSelection(item, close)}
                      >
                        {renderBankLogo(item)}
                        <div className="flex flex-col">
                          <p className="text-[12px] text-neutral-40 font-semibold">
                            {item.iban_nickname}
                          </p>
                          <p className="text-[12px] text-dark font-semibold">
                            {item.iban}
                          </p>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
                <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
                  <Pagination
                    onPageChange={onPageChange}
                    totalCount={destinations?.count || 0}
                    siblingCount={1}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    className="bg-neutral-10"
                  />
                </div>
              </>
            )}
          </div>
        );
      }}
    </Popup>
  );
};

MemorizedIbans.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      destination_bank: PropTypes.string.isRequired,
      destination_name: PropTypes.string.isRequired,
      destination_iban: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  onClose: PropTypes.func, // Optional callback for closing the popup
};

export default MemorizedIbans;
